import React from "react";
import useOpen from "../../hooks/useOpen";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { fmap } from "../../utils/fmap";
import { SIGNATURE_ICON } from "../../utils/svgs_new";
import { withDefault } from "../../utils/withDefault";
import { AppIcon } from "../Generic/AppIcon";
import { isDefined } from "../Generic/IsDefined";
import SignatureModalV2, { SignaturePayload } from "./SignatureModalV2";

interface Props {
  placeholder?: string;
  initialData?: string | null;
  isDisabled?: boolean;
  name?: string;
  onClick?: () => void;
  onSubmit: (data: string | null) => void;
}

const SignatureBox = (props: Props, ref?: React.Ref<HTMLInputElement>) => {
  const { isOpen, actions } = useOpen();
  const [signature, setSignature] = React.useState<SignaturePayload | null>(
    fmap(props.initialData, (x) => ({ trimmed: x, original: x }))
  );

  React.useEffect(() => {
    setSignature(fmap(props.initialData, (x) => ({ trimmed: x, original: x })));
  }, [props.initialData]);

  const handleSubmit = ($data: SignaturePayload | null) => {
    setSignature($data);

    props.onSubmit($data?.original ?? null);
    actions.dismiss();
  };

  const handleOpen = () => {
    if (props.isDisabled === true) {
      return;
    }

    actions.open();
  };

  return (
    <div className="SignatureBox" onClick={props.onClick}>
      <input ref={ref} type="hidden" name={props.name} value={signature?.original ?? ""} />

      <div className="click-area" onClick={handleOpen}>
        {isDefined(signature) ? (
          <>
            {isDefined(props.placeholder) ? (
              <span className="placeholder-on-signature">{props.placeholder}</span>
            ) : null}
            <img src={signature.trimmed} alt="signature" />
          </>
        ) : (
          <>
            <AppIcon icon={SIGNATURE_ICON} size={32} />
            <span>{withDefault(props.placeholder, translate(STRINGS.SIGN_HERE))}</span>
          </>
        )}
      </div>

      <SignatureModalV2
        isOpen={isOpen}
        initialData={signature?.original ?? null}
        onSubmit={handleSubmit}
        onRequestClose={actions.dismiss}
      />
    </div>
  );
};

export default React.forwardRef(SignatureBox);
